/**
 * Query keys for the active timer feature.
 *
 * `all` and `project` use distinct top-level prefixes so that invalidating
 * the timer state (`all`) does NOT cascade-invalidate the project details
 * cache. Sharing a prefix would defeat `useActiveTimerProject`'s 5-minute
 * staleTime — every pause/resume/update would trigger a project refetch.
 *
 * `project` accepts `number | null` so callers can pass through their raw
 * input without a sentinel value; pair it with `enabled: projectId != null`
 * in the consuming `useQuery` to gate fetching.
 */
export const ACTIVE_TIMER_QUERY_KEYS = Object.freeze({
  all: ['active-timer'] as const,
  project: (projectId: number | null) => ['active-timer-project', projectId] as const,
});
